import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  ExpensesExpensableFiltersInput,
  ProjectionKind,
  useExpensesByCostCenterDatatable,
} from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'
import Money from 'modules/expenses/pages/ExpensesReportsPage/Money'

interface ExpensesByCostCenterDatatableProps {
  filters: ExpensesExpensableFiltersInput
}

const ExpensesByCostCenterDatatable = ({ filters }: ExpensesByCostCenterDatatableProps) => {
  const { company } = useCurrentSession()

  const { dateFilters } = usePageDateFilters()

  const source = useExpensesByCostCenterDatatable(
    [
      {
        identifier: 'costCenterId',
        title: i18n.t('expenses_v2.reports.expenses_by_cost_center.columns.cost_center'),
        kind: ProjectionKind.Custom,
        template: '{{ costCenterId }}',
        render: ({ costCenter }) => {
          return (
            <Box flexDirection="row" alignItems="center" gap="s16">
              <Avatar size="s40" label={costCenter.name} />
              <Text.Normal size="200" weight="medium" ellipsis>
                {costCenter.name}
              </Text.Normal>
            </Box>
          )
        },
      },
      {
        identifier: 'totalAmount',
        title: i18n.t('expenses_v2.reports.expenses_by_cost_center.columns.spent'),
        kind: ProjectionKind.Custom,
        template: '{{ totalAmount }}',
        render: ({ totalAmount }) => {
          return <Money amount={totalAmount} currency={filters.currency} />
        },
        sortBy: 'totalAmount',
      },
    ],
    {
      variables: {
        companyId: company.id,
        from: dateFilters.startDate.toISOString(),
        to: dateFilters.endDate.toISOString(),
        filters: { ...filters },
      },
    }
  )

  return (
    <Box height="s400" maxHeight="s400" overflowY="auto">
      <DataTable
        disableExport
        source={source}
        pagination={{ kind: 'offset', itemsPerPage: 50, infiniteScroll: true }}
        disableEditColumns
        sort={{ path: 'totalAmount', direction: 'desc' }}
      />
    </Box>
  )
}

export default ExpensesByCostCenterDatatable
